import React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import GavelIcon from "@mui/icons-material/Gavel";
import LoginIcon from "@mui/icons-material/Login";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TimerIcon from "@mui/icons-material/Timer";

/** Login / register prompt for guests. */
export default function RegisterDialog({
  handleClose1,
  handleLater,
  handleLogin,
  handleRegister,
  isMobile,
  open1,
}) {
  return (
    <Dialog
      className="single-product-bell-mt"
      open={open1}
      onClose={handleClose1}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 2 : 3,
          p: { xs: 1, sm: 2 },
          background: "#f9f9f9",
          boxShadow: 5,
        },
      }}
    >
      <DialogTitle>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box display="flex" alignItems="center" gap={1.5}>
            <GavelIcon
              color="primary"
              sx={{ fontSize: isMobile ? 24 : 28 }}
            />
            <Typography
              variant={isMobile ? "subtitle1" : "h6"}
              fontWeight="800"
            >
              Register to Bid
            </Typography>
          </Box>
          <IconButton onClick={handleClose1} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent>
        <Typography
          variant="body1"
          align="center"
          sx={{
            mt: 2,
            mb: 3,
            color: "#555",
            px: { xs: 1, sm: 3 },
            fontSize: { xs: "0.95rem", sm: "1.05rem" },
          }}
        >
          Join the auction! Please login or create an account to start
          placing your bids.
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          flexDirection: isMobile ? "column" : "row",
          gap: 1.5,
          px: 3,
          pb: 4,
          // Logic para maging pantay ang buttons sa mobile
          "& .MuiButton-root": {
            width: isMobile ? "100%" : "auto",
            minWidth: isMobile ? "none" : 130,
            height: 50,
            borderRadius: 2, // Modern rounded look
            textTransform: "none", // Standard case para mas readable
            fontWeight: 700,
            margin: 0,
          },
        }}
      >
        <Button
          onClick={handleLogin}
          variant="contained"
          startIcon={<LoginIcon />}
          sx={{
            backgroundColor: "#212529",
            color: "#fff",
            "&:hover": { backgroundColor: "#000" },
          }}
        >
          Login
        </Button>

        <Button
          onClick={handleRegister}
          variant="contained"
          startIcon={<PersonAddIcon />}
          sx={{
            backgroundColor: "#495057",
            color: "#fff",
            "&:hover": { backgroundColor: "#343a40" },
          }}
        >
          Register
        </Button>

        <Button
          onClick={handleLater}
          variant="outlined"
          startIcon={<TimerIcon />}
          color="inherit"
          sx={{
            borderColor: "#ced4da",
            "&:hover": { borderColor: "#adb5bd", bgcolor: "#f1f3f5" },
          }}
        >
          Maybe Later
        </Button>
      </DialogActions>
    </Dialog>
  );
}
